// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d698fb8fff22a7d6f821","128":"fd08212a04cda5d40393","129":"89a98a7ba51e8e617679","167":"8578a323261f33f3b647"}[chunkId] + ".chunk.js";
};